var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"balance_content"},[_c('a-table',{staticClass:"balance_table",attrs:{"row-key":(r, i) => i.toString(),"columns":_vm.columns,"data-source":_vm.list,"pagination":_vm.pagination,"loading":_vm.loading,"scroll":{ x: 1200 }},on:{"change":_vm.handleTableChange}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }